module.exports = __webpack_public_path__ + "img/stock0.50bf3231.png";